module.exports = __webpack_public_path__ + "static/media/doctor2-150.c36accf0.webp";